// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbarWrapper {
  background-color: #fff;
  position: sticky;
  top: 0px;
  z-index: 100;
  padding: 10px 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 20px;
}
.navbarWrapper > :nth-child(1) > img {
  width: 54px;
  height: 54px;
}
.navbarWrapper > :nth-child(1) > h4 {
  font-size: 22px;
}
/* .navbarWrapper > :nth-child(2) {
  display: flex;
  background-color: #ddffce;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 15px;
  color: #2a8a00;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}
.navbarWrapper > :nth-child(2) svg {
  width: 26px;
  height: 26px;
  cursor: pointer;
  transition: 0.3s all ease-in-out;
}
.navbarWrapper > :nth-child(2) svg:hover {
  transform: rotate(70deg);
  transition: 0.3s all ease-in-out;
} */

.navbarWrapper > :nth-child(2) > :last-child {
  background-color: rgba(255, 77, 79, 0.2);
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
}
.navbarWrapper > :nth-child(2) > :last-child:hover {
  background-color: rgba(255, 77, 79, 0.3);
}

.navbarWrapper > :nth-child(2) > :first-child {
  position: relative;
  width: fit-content;
}
.navbarWrapper > :nth-child(2) > :nth-child(2) > div > div {
  background-color: var(--blue);
  width: fit-content;
  padding: 1px 8px;
  margin-top: 6px;
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
}
.navbarWrapper > :nth-child(2) > :first-child > h6 {
  position: absolute;
  color: #fff;
  background-color: #ff4d4f;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 14px;
  top: -10px;
  right: -8px;
}

.headerWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background-color: #fff;
  font-size: 20px;
  font-weight: 600;
  border-radius: 14px;
  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;
}

.inputBoxWrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.inputBoxWrapper input,
textarea {
  width: 100%;
  padding: 8px 10px;
  height: 50px;
  outline: none;
  border-radius: 5px;
  border: 1px solid var(--blue);
}
.inputBoxWrapper textarea {
  max-height: 200px;
  min-height: 50px !important;
}
.inputBoxWrapper input:disabled {
  background-color: rgb(240, 240, 240);
  opacity: 70%;
  color: black;
}
.inputBoxWrapper textarea:disabled {
  background-color: rgba(237, 237, 237, 1);
  opacity: 70%;
  color: black;
}

/* ------------------ DateRangePicker CSS ------------------ */
.dateRangePickerWrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dateRangePickerWrapper label {
  font-weight: 500;
  color: #333;
}

.dateRangeInputsContainer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 15px;
  height: 50px;
  border: 1px solid var(--blue);
  border-radius: 6px;
  background-color: #fff;
  transition: all 0.3s ease;
  position: relative;
}

.dateRangeInputsContainer:focus-within {
  box-shadow: 0 0 0 2px rgba(58, 87, 232, 0.1);
  border-color: var(--blue);
}

.dateRangeInputsContainer.error {
  border-color: #ff4d4f;
}

.dateRangeInputsContainer.disabled {
  background-color: rgb(240, 240, 240);
  opacity: 0.7;
  cursor: not-allowed;
}

.calendarIconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--blue);
}

.dateInputGroup {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: center;
}

.dateLabel {
  font-size: 10px;
  text-transform: uppercase;
  color: #888;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 2px;
}

.dateInputGroup input {
  border: none !important;
  background: transparent !important;
  height: auto !important;
  padding: 0 !important;
  outline: none !important;
  font-size: 13px !important;
  color: #333;
  width: 100%;
  cursor: pointer;
}

.dateInputGroup input:disabled {
  cursor: not-allowed;
}

.dateRangeSeparator {
  width: 1px;
  height: 24px;
  background-color: #e0e0e0;
  margin: 0 5px;
}

/* Hide native date icon to keep it clean, or keep it if preferred. 
   Removing it makes it look more custom. */
.dateInputGroup input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
}

.dateInputGroup input::-webkit-calendar-picker-indicator:hover {
  opacity: 1;
}

@media (max-width: 750px) {
  .dateRangeInputsContainer {
    height: 44px;
    padding: 0 10px;
    gap: 8px;
  }
  .dateInputGroup input {
    font-size: 12px !important;
  }
}

.selectBoxWrapper {
  display: flex;
  flex-direction: column;
  text-transform: capitalize;
  gap: 6px;
}

.blueHeading {
  color: var(--blue);
  font-weight: 700;
  margin-bottom: 16px !important;
  font-size: 25px;
}

.skyBlueBtn {
  background-color: var(--lightBlue);
  padding: 10px 14px;
  border-radius: 6px;
  border: none;
  color: #fff;
}
.purpelBtn {
  background-color: var(--blue);
  padding: 10px 14px;
  border-radius: 6px;
  border: none;
  color: #fff;
}

.colorBtn {
  background-color: var(--purple);
  padding: 10px 14px;
  border-radius: 6px;
  border: none;
  background-color: transparent;
  border: 2px solid rgba(217, 217, 217, 1);
}
.colorBtn:disabled {
  opacity: 60%;
}

.searchWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 30px;
}

.searchBox {
  border: 1px solid var(--blue);
  background-color: #fff;
  border-radius: 6px;
  width: 350px;
  padding: 0px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.searchBox > input {
  border: none;
  background-color: #fff;
  width: 300px;
  padding: 10px;
  outline: none;
}
.searchBox > input::placeholder {
  color: rgba(139, 163, 203, 1);
}

.custom-tooltip {
  position: absolute;
  top: -30px;
  left: 0;
  background-color: #333;
  color: white;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
}

.borderButton,
.activeBorderButton {
  border: 1px solid var(--lightBlue);
  background-color: var(--tableBg);
  border-radius: 10px;
  text-align: start;
  padding: 10px 20px;
  font-weight: 600;
  color: var(--blue);
  display: flex;
  gap: 14px;
  align-items: center;
}

.borderButton:hover {
  background-color: #edf5ff;
  border: 1px solid var(--blue);
}

.activeBorderButton {
  background-color: #2f3293;
  color: #fff;
}
.activeBorderButton svg {
  fill: #fff !important;
  stroke: #fff !important;
}

.greenBtn {
  background-color: rgba(0, 153, 81, 1);
  padding: 4px 15px;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
  border: 4px solid rgb(112, 245, 181);
  text-wrap: nowrap;
}
.greenBtnOutlined {
  text-wrap: nowrap;
  color: rgba(0, 153, 81, 1) !important;
  background-color: transparent;
  padding: 4px 15px;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
  border: 2px solid rgba(0, 153, 81, 1);
}

/* --------------------------Pagination button css----------------------------- */

.paginationButton {
  display: flex;
  gap: 6px;
}

.paginationButton button:nth-child(3) {
  padding: 0px 12px;
  height: 32px;
  border-radius: 2px;
  border: none;
  color: white;
  background-color: var(--blue);
  font-size: 14px;
}
.paginationButton button:nth-child(1) {
  padding: 0px 22px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid var(--purple);
  color: var(--blue);
  font-size: 14px;
  background-color: transparent;
}
.paginationButton > :nth-child(2) {
  padding: 0px 12px;
  height: 32px;
  text-wrap: nowrap;
  border: none;
  border-radius: 2px;
  font-size: 14px;
  color: #757575;
  font-weight: 600;
  background-color: transparent;
  display: flex;
  align-items: center;
}
.paginationButton button:nth-child(4) {
  padding: 0px 12px;
  height: 32px;
  border: 1px solid gray;
  border-radius: 2px;
  border: none;
  color: #fff;
  font-size: 14px;
  background-color: var(--blue);
}

.paginationButton button:disabled {
  opacity: 40%;
}

.backButton {
  background-color: transparent;
  border: none;
}
.backButton > img {
  width: 30px;
  height: 30px;
}
/* ------------------------------- */

/* ---------------------------Login Input Css ----------------------------- */
.loginInput {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #2f3299 !important;
  box-shadow: 0px 4px 4px 0px #66656540;

  border-radius: 8px;
  padding: 5px 16px;
}
.loginInput input {
  border: none;
  outline: none;
  width: 100%;
}
.loginInput input::placeholder {
  color: #626262;
  opacity: 0.5;
}

/* ----------------------- colorStatus ---------------------- */
.colorStatus {
  padding: 2px 6px;
  color: var(--lightBlue);
  font-size: 14px;
  background-color: #dbedff;
  width: fit-content;
  border-radius: 4px;
  text-transform: capitalize;
}

.loader {
  display: flex;
  height: 100%;
  width: 100%;
  position: fixed;
  align-items: center;
  justify-content: center;
  background-color: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(6px);
  z-index: 10000000 !important;
  top: 0px;
  bottom: 0px !important;
  left: 0px;
  right: 0px;
}

.loader-spinner-container {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #2f3299;
  border-bottom-color: #2f3299;
  animation: loaderSpin 1.2s linear infinite;
}

.loader-logo-card {
  width: 96px;
  height: 96px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  z-index: 2;
  overflow: hidden;
  animation: loaderPulse 1.8s ease-in-out infinite;
}

.loader-logo-img {
  width: 70px;
  height: 70px;
  object-fit: contain;
}

@keyframes loaderSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loaderPulse {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(0.95);
  }
}

.backButton p {
  font-size: 18px;
}

.mainHeaderWrapper {
  position: relative;
  z-index: 1000;
  overflow: visible !important;
}

.headerRight {
  position: relative;
  overflow: visible !important;
}

.profileWrapper {
  position: relative;
  z-index: 1001;
}

.profileDropdown {
  position: absolute;
  top: 58px;
  right: 0;
  width: 300px;
  background: #fff;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.12);
  border: 1px solid #f1f1f1;
  opacity: 0;
  visibility: hidden;
  transform: translateY(12px) scale(0.96);
  transition: all 0.28s ease;
  z-index: 1002;
}

.profileDropdownOpen {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}

.profileTop {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #f2f2f2;
}

.profileAvatar {
  width: 52px;
  height: 52px;
  min-width: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8b5e3c, #b07d57);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
  text-transform: uppercase;
}

.profileName {
  font-size: 17px;
  font-weight: 600;
  color: #222;
  text-transform: capitalize;
}

.profileDesignation {
  font-size: 13px;
  color: #777;
  margin-top: 2px;
  text-transform: capitalize;
}

.profileInfoItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
  gap: 15px;
}

.profileInfoItem:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.profileInfoItem span {
  font-size: 13px;
  color: #888;
}

.profileInfoItem strong {
  font-size: 14px;
  color: #222;
  text-align: right;
  font-weight: 600;
  text-transform: capitalize;
}

.profileIcon {
  cursor: pointer;
  transition: 0.2s ease;
}

.profileIcon:hover {
  transform: scale(1.05);
}

/* ------------- Media Query------------------- */
@media (max-width: 1000px) {
  .borderButton,
  .activeBorderButton {
    padding: 8px 10px;
    border-radius: 6px;
  }
  .borderButton svg {
    width: 22px;
    height: 22px;
  }
  .activeBorderButton svg {
    width: 15px;
    height: 15px;
  }
  .searchBox > input {
    width: auto;
    padding: 8px 10px;
  }
  .searchBox {
    width: fit-content;
  }
  .searchBox svg {
    width: 16px;
    height: 16px;
  }
  .pageWrapper {
    margin: 20px 20px;
  }
  .purpelBtn {
    padding: 8px 10px;
    border-radius: 6px;
  }
  .navbarWrapper > :nth-child(1) > h4 {
    font-size: 18px;
  }
  .navbarWrapper > :nth-child(2) > :nth-child(2) h6 {
    font-size: 14px;
  }
  .navbarWrapper > :nth-child(2) > :nth-child(2) > div > div {
    font-size: 12px;
  }
  .navbarWrapper > :nth-child(2) > :last-child svg {
    width: 18px;
    height: 15px;
  }
  .navbarWrapper > :nth-child(2) > :first-child svg {
    width: 18px;
    height: 18px;
  }
  .greenBtn {
    font-size: 14px;
    padding: 4px 15px;
  }
  .greenBtnOutlined {
    font-size: 14px;
    padding: 4px 15px;
  }
  .blueHeading {
    font-size: 20px;
  }
  .colorBtn {
    font-size: 14px;
  }
}

@media (max-width: 750px) {
  .borderButton,
  .activeBorderButton {
    font-size: 14px;
    padding: 4px 10px;
    border-radius: 6px;
  }
  .borderButton svg {
    width: 15px;
    height: 15px;
  }
  .activeBorderButton svg {
    width: 15px;
    height: 15px;
  }
  .searchBox > input {
    width: 150px;
    padding: 4px 10px;
    font-size: 14px;
  }
  .navbarWrapper {
    padding: 10px;
    gap: 10px;
  }
  .searchBox > input svg {
    width: 18px;
    height: 18px;
  }
  .pageWrapper {
    margin: 20px 10px;
  }
  .navbarWrapper > :nth-child(1) > img {
    width: 48px;
    height: 48px;
  }
  .purpelBtn {
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 14px;
  }

  .navbarWrapper > :nth-child(1) > h4 {
    font-size: 16px;
  }
  .paginationButton button:nth-child(1) {
    height: 25px;
    padding: 0px 10px;
    font-size: 14px;
  }
  .paginationButton > :nth-child(2) {
    height: 25px;
    padding: 0px 10px;
    font-size: 12px;
  }
  .paginationButton button:nth-child(3) {
    height: 25px;
    padding: 0px 10px;
    font-size: 14px;
  }
  .paginationButton button:nth-child(4) {
    height: 25px;
    padding: 0px 10px;
    font-size: 14px;
  }
  .backButton p {
    font-size: 14px;
  }
  .backButton svg {
    width: 20px;
    height: 20px;
  }

  .dateWrapper p {
    font-size: 14px;
  }
  .dateWrapper svg {
    width: 16px;
    height: 16px;
  }
  .headerWrapper {
    padding: 10px 10px;
  }
  .greenBtn {
    font-size: 12px;
    padding: 2px 10px;
  }
  .greenBtnOutlined {
    font-size: 12px;
    padding: 2px 10px;
  }
  .blueHeading {
    font-size: 16px;
  }
  .colorBtn {
    font-size: 12px;
  }
  .colorStatus {
    font-size: 12px !important;
  }
  .colorBtn {
    padding: 5px 14px;
    font-size: 14px;
  }

  .inputBoxWrapper input,
  textarea {
    height: 44px;
    font-size: 14px;
  }
  .inputBoxWrapper label {
    font-size: 14px;
  }
  .selectBoxWrapper label {
    font-size: 14px;
  }
  .searchWrapper {
    flex-direction: column;
    gap: 12px;
    align-items: center;
    margin: 15px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/commanComponents/commanComponents.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iDAAiD;EACjD,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;EACE,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,YAAY;EACZ,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;2CAC2C;AAC3C;EACE,eAAe;EACf,YAAY;EACZ,gCAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,QAAQ;EACV;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,kCAAkC;EAClC,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,iFAAiF;;AAEjF;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,oCAAoC;;AAEpC,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,qCAAqC;;EAErC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,0BAA0B;EAC1B,4BAA4B;EAC5B,QAAQ;EACR,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;EACnB;AACF","sourcesContent":[".navbarWrapper {\n  background-color: #fff;\n  position: sticky;\n  top: 0px;\n  z-index: 100;\n  padding: 10px 26px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n.navbarWrapper > :nth-child(1) > img {\n  width: 54px;\n  height: 54px;\n}\n.navbarWrapper > :nth-child(1) > h4 {\n  font-size: 22px;\n}\n/* .navbarWrapper > :nth-child(2) {\n  display: flex;\n  background-color: #ddffce;\n  padding: 2px 10px;\n  border-radius: 20px;\n  font-size: 15px;\n  color: #2a8a00;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n}\n.navbarWrapper > :nth-child(2) svg {\n  width: 26px;\n  height: 26px;\n  cursor: pointer;\n  transition: 0.3s all ease-in-out;\n}\n.navbarWrapper > :nth-child(2) svg:hover {\n  transform: rotate(70deg);\n  transition: 0.3s all ease-in-out;\n} */\n\n.navbarWrapper > :nth-child(2) > :last-child {\n  background-color: rgba(255, 77, 79, 0.2);\n  padding: 5px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.navbarWrapper > :nth-child(2) > :last-child:hover {\n  background-color: rgba(255, 77, 79, 0.3);\n}\n\n.navbarWrapper > :nth-child(2) > :first-child {\n  position: relative;\n  width: fit-content;\n}\n.navbarWrapper > :nth-child(2) > :nth-child(2) > div > div {\n  background-color: var(--blue);\n  width: fit-content;\n  padding: 1px 8px;\n  margin-top: 6px;\n  color: #fff;\n  border-radius: 20px;\n  font-size: 14px;\n}\n.navbarWrapper > :nth-child(2) > :first-child > h6 {\n  position: absolute;\n  color: #fff;\n  background-color: #ff4d4f;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 14px;\n  top: -10px;\n  right: -8px;\n}\n\n.headerWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 30px;\n  background-color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n  border-radius: 14px;\n  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;\n}\n\n.inputBoxWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.inputBoxWrapper input,\ntextarea {\n  width: 100%;\n  padding: 8px 10px;\n  height: 50px;\n  outline: none;\n  border-radius: 5px;\n  border: 1px solid var(--blue);\n}\n.inputBoxWrapper textarea {\n  max-height: 200px;\n  min-height: 50px !important;\n}\n.inputBoxWrapper input:disabled {\n  background-color: rgb(240, 240, 240);\n  opacity: 70%;\n  color: black;\n}\n.inputBoxWrapper textarea:disabled {\n  background-color: rgba(237, 237, 237, 1);\n  opacity: 70%;\n  color: black;\n}\n\n/* ------------------ DateRangePicker CSS ------------------ */\n.dateRangePickerWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.dateRangePickerWrapper label {\n  font-weight: 500;\n  color: #333;\n}\n\n.dateRangeInputsContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 15px;\n  height: 50px;\n  border: 1px solid var(--blue);\n  border-radius: 6px;\n  background-color: #fff;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.dateRangeInputsContainer:focus-within {\n  box-shadow: 0 0 0 2px rgba(58, 87, 232, 0.1);\n  border-color: var(--blue);\n}\n\n.dateRangeInputsContainer.error {\n  border-color: #ff4d4f;\n}\n\n.dateRangeInputsContainer.disabled {\n  background-color: rgb(240, 240, 240);\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.calendarIconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--blue);\n}\n\n.dateInputGroup {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: center;\n}\n\n.dateLabel {\n  font-size: 10px;\n  text-transform: uppercase;\n  color: #888;\n  font-weight: 700;\n  line-height: 1;\n  margin-bottom: 2px;\n}\n\n.dateInputGroup input {\n  border: none !important;\n  background: transparent !important;\n  height: auto !important;\n  padding: 0 !important;\n  outline: none !important;\n  font-size: 13px !important;\n  color: #333;\n  width: 100%;\n  cursor: pointer;\n}\n\n.dateInputGroup input:disabled {\n  cursor: not-allowed;\n}\n\n.dateRangeSeparator {\n  width: 1px;\n  height: 24px;\n  background-color: #e0e0e0;\n  margin: 0 5px;\n}\n\n/* Hide native date icon to keep it clean, or keep it if preferred. \n   Removing it makes it look more custom. */\n.dateInputGroup input::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n\n.dateInputGroup input::-webkit-calendar-picker-indicator:hover {\n  opacity: 1;\n}\n\n@media (max-width: 750px) {\n  .dateRangeInputsContainer {\n    height: 44px;\n    padding: 0 10px;\n    gap: 8px;\n  }\n  .dateInputGroup input {\n    font-size: 12px !important;\n  }\n}\n\n.selectBoxWrapper {\n  display: flex;\n  flex-direction: column;\n  text-transform: capitalize;\n  gap: 6px;\n}\n\n.blueHeading {\n  color: var(--blue);\n  font-weight: 700;\n  margin-bottom: 16px !important;\n  font-size: 25px;\n}\n\n.skyBlueBtn {\n  background-color: var(--lightBlue);\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: none;\n  color: #fff;\n}\n.purpelBtn {\n  background-color: var(--blue);\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: none;\n  color: #fff;\n}\n\n.colorBtn {\n  background-color: var(--purple);\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: none;\n  background-color: transparent;\n  border: 2px solid rgba(217, 217, 217, 1);\n}\n.colorBtn:disabled {\n  opacity: 60%;\n}\n\n.searchWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 20px 30px;\n}\n\n.searchBox {\n  border: 1px solid var(--blue);\n  background-color: #fff;\n  border-radius: 6px;\n  width: 350px;\n  padding: 0px 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.searchBox > input {\n  border: none;\n  background-color: #fff;\n  width: 300px;\n  padding: 10px;\n  outline: none;\n}\n.searchBox > input::placeholder {\n  color: rgba(139, 163, 203, 1);\n}\n\n.custom-tooltip {\n  position: absolute;\n  top: -30px;\n  left: 0;\n  background-color: #333;\n  color: white;\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 4px;\n  white-space: nowrap;\n  z-index: 10;\n}\n\n.borderButton,\n.activeBorderButton {\n  border: 1px solid var(--lightBlue);\n  background-color: var(--tableBg);\n  border-radius: 10px;\n  text-align: start;\n  padding: 10px 20px;\n  font-weight: 600;\n  color: var(--blue);\n  display: flex;\n  gap: 14px;\n  align-items: center;\n}\n\n.borderButton:hover {\n  background-color: #edf5ff;\n  border: 1px solid var(--blue);\n}\n\n.activeBorderButton {\n  background-color: #2f3293;\n  color: #fff;\n}\n.activeBorderButton svg {\n  fill: #fff !important;\n  stroke: #fff !important;\n}\n\n.greenBtn {\n  background-color: rgba(0, 153, 81, 1);\n  padding: 4px 15px;\n  border-radius: 8px;\n  color: #fff;\n  font-weight: 600;\n  border: 4px solid rgb(112, 245, 181);\n  text-wrap: nowrap;\n}\n.greenBtnOutlined {\n  text-wrap: nowrap;\n  color: rgba(0, 153, 81, 1) !important;\n  background-color: transparent;\n  padding: 4px 15px;\n  border-radius: 8px;\n  color: #fff;\n  font-weight: 600;\n  border: 2px solid rgba(0, 153, 81, 1);\n}\n\n/* --------------------------Pagination button css----------------------------- */\n\n.paginationButton {\n  display: flex;\n  gap: 6px;\n}\n\n.paginationButton button:nth-child(3) {\n  padding: 0px 12px;\n  height: 32px;\n  border-radius: 2px;\n  border: none;\n  color: white;\n  background-color: var(--blue);\n  font-size: 14px;\n}\n.paginationButton button:nth-child(1) {\n  padding: 0px 22px;\n  height: 32px;\n  border-radius: 2px;\n  border: 1px solid var(--purple);\n  color: var(--blue);\n  font-size: 14px;\n  background-color: transparent;\n}\n.paginationButton > :nth-child(2) {\n  padding: 0px 12px;\n  height: 32px;\n  text-wrap: nowrap;\n  border: none;\n  border-radius: 2px;\n  font-size: 14px;\n  color: #757575;\n  font-weight: 600;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n}\n.paginationButton button:nth-child(4) {\n  padding: 0px 12px;\n  height: 32px;\n  border: 1px solid gray;\n  border-radius: 2px;\n  border: none;\n  color: #fff;\n  font-size: 14px;\n  background-color: var(--blue);\n}\n\n.paginationButton button:disabled {\n  opacity: 40%;\n}\n\n.backButton {\n  background-color: transparent;\n  border: none;\n}\n.backButton > img {\n  width: 30px;\n  height: 30px;\n}\n/* ------------------------------- */\n\n/* ---------------------------Login Input Css ----------------------------- */\n.loginInput {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid #2f3299 !important;\n  box-shadow: 0px 4px 4px 0px #66656540;\n\n  border-radius: 8px;\n  padding: 5px 16px;\n}\n.loginInput input {\n  border: none;\n  outline: none;\n  width: 100%;\n}\n.loginInput input::placeholder {\n  color: #626262;\n  opacity: 0.5;\n}\n\n/* ----------------------- colorStatus ---------------------- */\n.colorStatus {\n  padding: 2px 6px;\n  color: var(--lightBlue);\n  font-size: 14px;\n  background-color: #dbedff;\n  width: fit-content;\n  border-radius: 4px;\n  text-transform: capitalize;\n}\n\n.loader {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(15, 23, 42, 0.75);\n  backdrop-filter: blur(6px);\n  z-index: 10000000 !important;\n  top: 0px;\n  bottom: 0px !important;\n  left: 0px;\n  right: 0px;\n}\n\n.loader-spinner-container {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loader-spinner-ring {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  border-top-color: #2f3299;\n  border-bottom-color: #2f3299;\n  animation: loaderSpin 1.2s linear infinite;\n}\n\n.loader-logo-card {\n  width: 96px;\n  height: 96px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  z-index: 2;\n  overflow: hidden;\n  animation: loaderPulse 1.8s ease-in-out infinite;\n}\n\n.loader-logo-img {\n  width: 70px;\n  height: 70px;\n  object-fit: contain;\n}\n\n@keyframes loaderSpin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loaderPulse {\n  0% {\n    transform: scale(0.95);\n  }\n  50% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(0.95);\n  }\n}\n\n.backButton p {\n  font-size: 18px;\n}\n\n.mainHeaderWrapper {\n  position: relative;\n  z-index: 1000;\n  overflow: visible !important;\n}\n\n.headerRight {\n  position: relative;\n  overflow: visible !important;\n}\n\n.profileWrapper {\n  position: relative;\n  z-index: 1001;\n}\n\n.profileDropdown {\n  position: absolute;\n  top: 58px;\n  right: 0;\n  width: 300px;\n  background: #fff;\n  border-radius: 18px;\n  padding: 18px;\n  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.12);\n  border: 1px solid #f1f1f1;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(12px) scale(0.96);\n  transition: all 0.28s ease;\n  z-index: 1002;\n}\n\n.profileDropdownOpen {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0) scale(1);\n}\n\n.profileTop {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding-bottom: 14px;\n  margin-bottom: 14px;\n  border-bottom: 1px solid #f2f2f2;\n}\n\n.profileAvatar {\n  width: 52px;\n  height: 52px;\n  min-width: 52px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #8b5e3c, #b07d57);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.profileName {\n  font-size: 17px;\n  font-weight: 600;\n  color: #222;\n  text-transform: capitalize;\n}\n\n.profileDesignation {\n  font-size: 13px;\n  color: #777;\n  margin-top: 2px;\n  text-transform: capitalize;\n}\n\n.profileInfoItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid #f5f5f5;\n  gap: 15px;\n}\n\n.profileInfoItem:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.profileInfoItem span {\n  font-size: 13px;\n  color: #888;\n}\n\n.profileInfoItem strong {\n  font-size: 14px;\n  color: #222;\n  text-align: right;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.profileIcon {\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.profileIcon:hover {\n  transform: scale(1.05);\n}\n\n/* ------------- Media Query------------------- */\n@media (max-width: 1000px) {\n  .borderButton,\n  .activeBorderButton {\n    padding: 8px 10px;\n    border-radius: 6px;\n  }\n  .borderButton svg {\n    width: 22px;\n    height: 22px;\n  }\n  .activeBorderButton svg {\n    width: 15px;\n    height: 15px;\n  }\n  .searchBox > input {\n    width: auto;\n    padding: 8px 10px;\n  }\n  .searchBox {\n    width: fit-content;\n  }\n  .searchBox svg {\n    width: 16px;\n    height: 16px;\n  }\n  .pageWrapper {\n    margin: 20px 20px;\n  }\n  .purpelBtn {\n    padding: 8px 10px;\n    border-radius: 6px;\n  }\n  .navbarWrapper > :nth-child(1) > h4 {\n    font-size: 18px;\n  }\n  .navbarWrapper > :nth-child(2) > :nth-child(2) h6 {\n    font-size: 14px;\n  }\n  .navbarWrapper > :nth-child(2) > :nth-child(2) > div > div {\n    font-size: 12px;\n  }\n  .navbarWrapper > :nth-child(2) > :last-child svg {\n    width: 18px;\n    height: 15px;\n  }\n  .navbarWrapper > :nth-child(2) > :first-child svg {\n    width: 18px;\n    height: 18px;\n  }\n  .greenBtn {\n    font-size: 14px;\n    padding: 4px 15px;\n  }\n  .greenBtnOutlined {\n    font-size: 14px;\n    padding: 4px 15px;\n  }\n  .blueHeading {\n    font-size: 20px;\n  }\n  .colorBtn {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 750px) {\n  .borderButton,\n  .activeBorderButton {\n    font-size: 14px;\n    padding: 4px 10px;\n    border-radius: 6px;\n  }\n  .borderButton svg {\n    width: 15px;\n    height: 15px;\n  }\n  .activeBorderButton svg {\n    width: 15px;\n    height: 15px;\n  }\n  .searchBox > input {\n    width: 150px;\n    padding: 4px 10px;\n    font-size: 14px;\n  }\n  .navbarWrapper {\n    padding: 10px;\n    gap: 10px;\n  }\n  .searchBox > input svg {\n    width: 18px;\n    height: 18px;\n  }\n  .pageWrapper {\n    margin: 20px 10px;\n  }\n  .navbarWrapper > :nth-child(1) > img {\n    width: 48px;\n    height: 48px;\n  }\n  .purpelBtn {\n    padding: 4px 10px;\n    border-radius: 6px;\n    font-size: 14px;\n  }\n\n  .navbarWrapper > :nth-child(1) > h4 {\n    font-size: 16px;\n  }\n  .paginationButton button:nth-child(1) {\n    height: 25px;\n    padding: 0px 10px;\n    font-size: 14px;\n  }\n  .paginationButton > :nth-child(2) {\n    height: 25px;\n    padding: 0px 10px;\n    font-size: 12px;\n  }\n  .paginationButton button:nth-child(3) {\n    height: 25px;\n    padding: 0px 10px;\n    font-size: 14px;\n  }\n  .paginationButton button:nth-child(4) {\n    height: 25px;\n    padding: 0px 10px;\n    font-size: 14px;\n  }\n  .backButton p {\n    font-size: 14px;\n  }\n  .backButton svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  .dateWrapper p {\n    font-size: 14px;\n  }\n  .dateWrapper svg {\n    width: 16px;\n    height: 16px;\n  }\n  .headerWrapper {\n    padding: 10px 10px;\n  }\n  .greenBtn {\n    font-size: 12px;\n    padding: 2px 10px;\n  }\n  .greenBtnOutlined {\n    font-size: 12px;\n    padding: 2px 10px;\n  }\n  .blueHeading {\n    font-size: 16px;\n  }\n  .colorBtn {\n    font-size: 12px;\n  }\n  .colorStatus {\n    font-size: 12px !important;\n  }\n  .colorBtn {\n    padding: 5px 14px;\n    font-size: 14px;\n  }\n\n  .inputBoxWrapper input,\n  textarea {\n    height: 44px;\n    font-size: 14px;\n  }\n  .inputBoxWrapper label {\n    font-size: 14px;\n  }\n  .selectBoxWrapper label {\n    font-size: 14px;\n  }\n  .searchWrapper {\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    margin: 15px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
